import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { validators, formats, dates } from "investira.sdk";
import {
  Chip,
  Stack,
  Tooltip,
  Typography,
  CircularProgress,
  IconButton,
  Icon,
} from "investira.react.components";
import { DataTable } from "../";
import services from "../../../services";

const ArquivosDataGrid = (props) => {
  const { isFetching, data, onDeleteClick, ...restProps } = props;

  function onDownloadClick(pData) {
    if (pData) {
      services.posicoes.download(
        pData._rid,
        (rRes) => {
          let xOutputFilename = `${pData.arquivo}.xml`;

          if (rRes?.headers["content-disposition"]) {
            let xFilenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let xMatches = xFilenameRegex.exec(
              rRes.headers["content-disposition"]
            );
            if (xMatches != null && xMatches[1]) {
              xOutputFilename = xMatches[1].replace(/['"]/g, "");
            }
          }

          const xFileURL = URL.createObjectURL(rRes.data);
          let xLinkElem = document.createElement("a");
          xLinkElem.href = xFileURL;
          xLinkElem.download = xOutputFilename;
          xLinkElem.click();
          URL.revokeObjectURL(xFileURL);
          xLinkElem.remove();
        },
        (rErr) => {
          console.log(rErr);
        }
      );
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "data_envio",
        header: "Envio",
        enableColumnActions: false,
        enableSorting: false,
        maxSize: 100,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
      {
        accessorKey: "arquivo",
        header: "Nome",
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return <Typography variant="body2">{cell.getValue()}</Typography>;
        },
      },
      {
        id: "status",
        accessorKey: "ifeed_upload_fim",
        header: "Status",
        enableColumnActions: false,
        enableSorting: false,
        maxSize: 80,
        muiTableHeadCellProps: () => {
          return { align: "center" };
        },
        muiTableBodyCellProps: () => {
          return { align: "center" };
        },
        Cell: (xProps) => {
          const { cell, row } = xProps;

          if (!validators.isEmpty(row.original.ifeed_erros)) {
            // const xError = !validators.isNull(
            //   row.original.ifeed_posicao_import_inicio
            // )
            //   ? "Erro Importação"
            //   : "Erro Processamento";

            const xError = "Erro";

            return (
              <Tooltip
                arrow
                title={
                  <Stack
                    spacing={1}
                    sx={{
                      px: 2,
                      py: 1,
                      whiteSpace: "normal",
                    }}
                  >
                    {validators.isArray(row.original.ifeed_erros) ? (
                      row.original.ifeed_erros.map((error, index) => {
                        return (
                          <Stack key={`file-error-${index}`} spacing={1}>
                            <Typography variant="caption" color="textPrimary">
                              {error.description || error}
                            </Typography>
                          </Stack>
                        );
                      })
                    ) : (
                      <Typography variant="caption" color="textPrimary">
                        {row.original.ifeed_erros.description}
                      </Typography>
                    )}
                  </Stack>
                }
              >
                <span>
                  <Chip
                    size="small"
                    label={xError}
                    color="error"
                    sx={{ cursor: "help" }}
                  />
                </span>
              </Tooltip>
            );
          }

          if (!validators.isNull(cell.getValue())) {
            return <Chip size="small" label="Ok" color="success" />;
          }

          if (!validators.isNull(row.original.arquivo)) {
            return <CircularProgress size={24} />;
          }

          return null;
        },
      },
      {
        id: "processado",
        accessorKey: "ifeed_posicao_import_fim",
        header: "Processado",
        enableColumnActions: false,
        enableSorting: false,
        maxSize: 100,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return "";
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
      {
        accessorKey: "ifeed_carteira",
        header: "Carteira",
        enableColumnActions: false,
        enableSorting: false,
      },
      {
        id: "posicao",
        accessorKey: "ifeed_data_posicao",
        header: "Posição",
        enableColumnActions: false,
        enableSorting: false,
        maxSize: 100,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return "";
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
    ],
    []
  );

  const xProps = useMemo(() => {
    return {
      columns,
      ...restProps,
      enableRowSelection: true,
      enableGlobalFilter: false,
      enableExpanding: false,
      enableFullScreenToggle: false,
      enableDensityToggle: false,
      enableBottomToolbar: true,
      muiTopToolbarProps: {
        sx: {
          backgroundColor: "none",
          alignItems: "center",
        },
      },
      initialState: props.initialState,
      renderRowActions: ({ row }) => {
        return (
          <Stack direction="row">
            <Tooltip title="Download">
              <IconButton
                onClick={() => onDownloadClick(row.original)}
                color="primary"
              >
                <Icon iconName="download" size={21} />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    };
  }, [columns, props.initialState, restProps]);

  return <DataTable data={data} {...xProps} />;
};

ArquivosDataGrid.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  initialState: PropTypes.object,
};

ArquivosDataGrid.default = {
  initialState: {},
};

export default ArquivosDataGrid;
